import React from 'preact/compat';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Spinner from '../Svg/Spinner';

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const Loader = ({ loaded, children }) => {
  if (!loaded) {
    return (
      <Container>
        <Spinner />
      </Container>
    );
  }

  return children;
};

Loader.propTypes = {
  loaded: PropTypes.bool,
  children: PropTypes.node,
};

Loader.defaultProps = {
  loaded: false,
  children: undefined,
};

export default Loader;
